import { http } from "@/lib/http";
export function retrieveMapDataList() {
  return http
    .get("/api/campaigns/v2/retrieveMapDataList")
    .then((res) => res.data?.data || { scriptList: [], stampCardList: [] });
}
export function retrieveMapDetails(scriptName) {
  return http
    .get("/api/campaigns/v2/retrieveMapDetails", { params: { scriptName } })
    .then((res) => res.data?.data?.config || []);
}
export function deleteMapEntry(scriptName) {
  return http
    .post("/api/campaigns/v2/deleteMapDetails", { scriptName })
    .then((res) => res.data);
}
export function addOrEditMapDetails(payload) {
  return http
    .post("/api/campaigns/v2/addOrEditMapDetails", payload)
    .then((res) => res.data);
}
